import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { WireframeComponent } from '../models/WireframeComponent'
import { WireframeComponentForm } from '../forms/WireframeComponentForm'
import { WireframeComponentFilter } from '../filters/WireframeComponentFilter'
import { WireframeComponentService } from '../services/WireframeComponentService'

export const useWireframeComponentStore: KsStoreHook<WireframeComponent, WireframeComponentForm, WireframeComponentFilter> = createKsStore({
  id: 'wireframeComponents',
  modelClass: WireframeComponent,
  formClass: WireframeComponentForm,
  filterClass: WireframeComponentFilter,
  service: WireframeComponentService,
  uniqueField: 'code',
  labelField: (item) => item.name || item.code || `Component #${item.id}`,
  signalREventName: 'WireframeComponentModel',
  isReferential: true
})
